import useFetchDefaultList from "../fetch-default-list/use-query";
import useFetchFullList from "../lists/items/fetch-list-items/use-query";
var useGetFullWishlist = function useGetFullWishlist() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    select = _ref.select;
  var _useFetchDefaultList = useFetchDefaultList(),
    id = _useFetchDefaultList.data;
  return useFetchFullList({
    id: id,
    select: select
  });
};
export default useGetFullWishlist;